import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";

function SeperatorTimeframe() {
  return (
    <SoftBox position="relative" py={0.25}>
      <Divider />
      <SoftBox
        bgColor="white"
        position="absolute"
        top="50%"
        left="50%"
        px={1.5}
        lineHeight={1}
        sx={{ transform: "translate(-50%, -60%)" }}
      >
        <SoftBadge
            variant="contained"
            color="secondary"
            size="sm"
            badgeContent={
                <SoftTypography color="text" variant="button">
                    Choose your TimeFrame  
                </SoftTypography>
            }
        />
      </SoftBox>
    </SoftBox>
  );
}

export default SeperatorTimeframe;